export const learnerTermsAndConditionsLink = 'https://aws.amazon.com/legal/learner-terms-conditions/';

export const privacyNoticeLink = 'https://aws.amazon.com/privacy/';
